import { IoIosArrowDown } from 'react-icons/io'

export default function Video({
  mobile,
  desktop,
  mobilePoster,
  desktopPoster,
  title,
  subTitle,
  link,
}) {
  const isDesktopDisabledVideo = window.matchMedia('(max-width:768px)').matches
  return (
    <section className='relative w-full h-screen lg:h-[600px] bg-black'>
      {isDesktopDisabledVideo ? (
        <video
          className='bg-black w-full h-full object-cover pointer-events-none select-none'
          loop
          autoPlay
          muted
          playsInline
          controls={false}
          preload='auto'
          width='100%'
          height='100%'
          poster={mobilePoster}
        >
          <source src={mobile} />
        </video>
      ) : (
        <video
          className='bg-black w-full h-full object-cover  pointer-events-none select-none aspect-video disable-video'
          loop
          autoPlay
          muted
          playsInline
          controls={false}
          preload='auto'
          width='100%'
          height='100%'
          poster={desktopPoster}
        >
          <source src={desktop} />
        </video>
      )}
      <div className='w-fit h-full mx-auto absolute inset-0 flex flex-col justify-center items-center gap-4 text-center'>
        <div className='text-center text-white flex flex-col justify-center items-center p-1 rounded-xl drop-shadow-2xl'>
          <h1 className='text-5xl font-[900] uppercase sm:text-6xl md:text-7xl xl:text-8xl px-4 drop-shadow-lg mb-4'>
            {title}
          </h1>
          <h2 className='font-[600] lg:font-[400] text-xl uppercase md:text-3xl w-3/4 drop-shadow-md'>
            {subTitle}
          </h2>
        </div>
      </div>
      <a
        href={link}
        className='absolute md:hidden bottom-12 left-1/2 text-white transform -translate-x-1/2'
      >
        <IoIosArrowDown size={48} />
      </a>
    </section>
  )
}
